import _asyncToGenerator from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/empty/style";
import _Empty from "vant/es/empty";
import "vant/es/nav-bar/style";
import _NavBar from "vant/es/nav-bar";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/skeleton/style";
import _Skeleton from "vant/es/skeleton";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/list/style";
import _List from "vant/es/list";

var _components;

import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Image as VanImage } from "vant/lib/image";
import help from "../assets/js/help";
import ListJoinItem from "./ListJoinItem";
import { mapMutations, mapState } from "vuex";
export default {
  name: "ListJoinWrapper",
  props: {
    categoryId: {
      type: [Number, String],
      default: 0
    }
  },
  components: (_components = {}, _defineProperty(_components, _List.name, _List), _defineProperty(_components, _PullRefresh.name, _PullRefresh), _defineProperty(_components, _Skeleton.name, _Skeleton), _defineProperty(_components, _Button.name, _Button), _defineProperty(_components, _NavBar.name, _NavBar), _defineProperty(_components, _Empty.name, _Empty), _defineProperty(_components, _Toast.name, _Toast), _defineProperty(_components, VanImage.name, VanImage), _defineProperty(_components, _Loading.name, _Loading), _defineProperty(_components, "ListJoinItem", ListJoinItem), _components),
  data: function data() {
    return {
      border: false,
      finished: false,
      refreshing: false,
      loading: true,
      loadDate: false,
      emptyImage: require("@/assets/images/content-null.png"),
      list: [],
      page: 1,
      timer: "",
      activeIndex: 0,
      chargeCoupeList: [{}]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "isTest", "totalIngral"])), {}, {
    isDevelopment: function isDevelopment() {
      return process.env.NODE_ENV === "development";
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations(["setTotalIngral", "setTimeOut", "setAppInfo", "setAppInfo"])), {}, {
    updateActiveIndex: function updateActiveIndex(index) {
      this.$emit("update:activeIndex", index);
    },
    getDateString: function getDateString() {
      var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "2023-01-11T11:43:55Z";
      return dataString.split("T")[0];
    },
    initPage: function initPage() {
      if (!this.loadDate && this.loading) {
        this.getList();
        this.page += 1;
        this.loadDate = true;
      }
    },
    getList: function getList() {
      var _this = this;

      var _uid = this.uid;
      this.axios.get("/api/activity/invitation-my-list?uid=".concat(_uid)).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
            res.forEach(function (e) {
              _this.list.push(e);
            });
            _this.loading = false;
            _this.loadDate = false;
            _this.finished = true;

            if (_this.isTimeOuted) {
              _this.setTimeOut(false);
            }
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    onClickRight: function onClickRight() {
      _Toast("按钮");
    },
    onLoad: function onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.page = 1;
      }

      this.initPage();
    },
    onRefresh: function onRefresh() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.refreshing = true;
                _this2.finished = false;
                _this2.loading = true;

                _this2.onLoad();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getIntegral: function getIntegral() {
      if (!this.totalIngral) {
        this.setTotalIngral(10000);
      }
    }
  })
};